
import ImportWizardV1 from '../import-wizard/import-wizard.vue';
import ImportWizardV2 from '../import-wizard-v2/import-wizard-v2.vue';
import Vue, { PropType } from 'vue';
import { SupportedLangCodes } from '@/constants/languageCodes';
import { ProductPrintPositionAddModel } from '@/typings';
import { LogoOnlyArtwork } from '../import-wizard/typings';
import isValidLanguageValidator from '@/validators/langLocaleValidator';
import { priceDetails, pdpChoices } from '@/setters';

export default Vue.extend({
  name: 'W2pImportWizardWrapper',
  components: {
    ImportWizardV1,
    ImportWizardV2
  },
  props: {
    version: {
      type: String,
      required: false,
      default() {
        return 'V1';
      },
    },
    languageCode: {
      type: String as PropType<SupportedLangCodes>,
      required: false,
      default: 'none',
      validator: isValidLanguageValidator,
    },
    personalizationId: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    priceDetails,
    pdpChoices,
    sapCustomerId: {
      type: String,
      required: true,
    },
    tok: {
      type: String,
      required: true,
    },
    isDirectApproval: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFirstTimeOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
    isConceptDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isOrderDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    printPositions: {
      type: [] as PropType<ProductPrintPositionAddModel[]>,
      required: false,
      default() {
        return [];
      },
    },
    customerCompanyLogoUrl: {
      type: String,
      required: false,
      default: '',
    },
    logoOnlyArtwork: {
      type: [] as PropType<LogoOnlyArtwork[]>,
      required: false,
      default: () => {
        return [];
      },
    },
  },
   methods: {
    // NOTE: Leave, need it for bug fixing
    emitEvent(eventName: string, event: any) {
      if (eventName === 'wizard:price-params-changed') {
        this.$emit('wizard:price-params-changed', event);
      }

      if (eventName === 'wizard:back') {
        this.$emit('wizard:back');
      }
    },
  },
});
